module.exports = __webpack_public_path__ + "img/locationSelf.53cfb4fd.png";